// src/ui/icons.js — helpers de iconos compartidos.
//
// Extraído de js/app.js (sub-fase 3.4 del refactor).
//
// Scope mínimo: solo se centraliza `renderPactoIcon`, helper SVG idéntico
// que estaba declarado 3 veces en app.js (dentro de renderRitualesGrupo,
// renderTribuna y renderPerfil — esta última bajo el alias
// `renderPactoIconPerfil`).
//
// Drift reportado vs PROMPT_REFACTORING.md §3.4 ("SVGs y emojis
// centralizados"): el código no tiene un sistema central de iconos.
// Las tablas arengaTypes / tribunaArengaTypes / arengaTypesPerfil
// (paths SVG por tipo) tienen leves diferencias entre sí (labels +
// colores) y migran junto con sus vistas en 3.7 / 3.11 / 3.12. DT-1
// (REFACTOR_AUDIT.md §13) ya documenta la fusión de las dos versiones
// de la vista perfil; el mismo movimiento aplica a tribuna y rituales.

// ─── Helper SVG ────────────────────────────────────────────────────────────
//
// path:   d="..." del <path> SVG (string, sin la ".d=").
// color:  stroke color (default 'currentColor' — hereda del padre CSS).
// size:   width/height en px (default 18, ajustable por callsite).

export const renderPactoIcon = (path, color = 'currentColor', size = 18) =>
  `<svg viewBox="0 0 24 24" width="${size}" height="${size}" aria-hidden="true" style="display:block;fill:none;stroke:${color};stroke-width:2;stroke-linecap:round;stroke-linejoin:round;"><path d="${path}"></path></svg>`

// ─── Bridge transitorio a window.* (sub-fase 3.4 → FASE 4) ─────────────────

if (typeof window !== 'undefined') {
  window.renderPactoIcon = renderPactoIcon
}
